// extracted by mini-css-extract-plugin
export default {"container":"index_container__p1nMl","title":"index_title__5XXYl","paragraph":"index_paragraph__mDcjO","paddingleft":"index_paddingleft__IV+l4","bold":"index_bold__IEsij"};